import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

export default function KVKKPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-primary/10 via-lightBlue to-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="font-heading font-bold text-4xl lg:text-5xl text-darkBlue mb-6">
              KVKK Aydınlatma Metni
            </h1>
            <p className="font-body text-lg text-gray-600 leading-relaxed">
              Kişisel Verilerin Korunması Kanunu kapsamında bilgilendirme
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            <div className="bg-lightBlue/30 rounded-xl p-8 mb-8">
              <p className="font-body text-gray-700 leading-relaxed">
                <strong className="text-darkBlue">İzmir Vize Danışmanlık</strong> olarak, 6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") uyarınca, kişisel verilerinizin işlenmesine ilişkin olarak sizi bilgilendirmek isteriz.
              </p>
            </div>

            <div className="space-y-8">
              <div>
                <h2 className="font-heading font-bold text-2xl text-darkBlue mb-4 flex items-center">
                  <span className="w-2 h-8 bg-secondary rounded-full mr-3"></span>
                  1. Veri Sorumlusu
                </h2>
                <p className="font-body text-gray-700 leading-relaxed">
                  KVKK uyarınca kişisel verilerinizin veri sorumlusu <strong>İzmir Vize Danışmanlık</strong>'tır.
                </p>
                <div className="bg-gray-50 rounded-lg p-6 mt-4">
                  <p className="font-body text-gray-700">
                    <strong>Adres:</strong> Fevzi Paşa Mah. 847/1 Sk. No:8 Kat:4 Daire:4/405 Sağlık İş Hanı, Konak/İzmir<br />
                    <strong>Telefon:</strong> +90 542 267 11 71<br />
                    <strong>E-posta:</strong> info@izmirvizedanismanlik.net
                  </p>
                </div>
              </div>

              <div>
                <h2 className="font-heading font-bold text-2xl text-darkBlue mb-4 flex items-center">
                  <span className="w-2 h-8 bg-secondary rounded-full mr-3"></span>
                  2. Kişisel Verilerin İşlenme Amacı
                </h2>
                <p className="font-body text-gray-700 leading-relaxed mb-4">
                  Kişisel verileriniz aşağıdaki amaçlarla işlenmektedir:
                </p>
                <ul className="space-y-2 font-body text-gray-700">
                  <li className="flex items-start space-x-2">
                    <i className="ri-checkbox-circle-fill text-secondary mt-1 flex-shrink-0"></i>
                    <span>Vize danışmanlık hizmetlerinin sunulması ve yürütülmesi</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-checkbox-circle-fill text-secondary mt-1 flex-shrink-0"></i>
                    <span>Vize başvuru süreçlerinin takibi ve yönetimi</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-checkbox-circle-fill text-secondary mt-1 flex-shrink-0"></i>
                    <span>Konsolosluklar ve ilgili resmi kurumlarla iletişim</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-checkbox-circle-fill text-secondary mt-1 flex-shrink-0"></i>
                    <span>Müşteri ilişkileri yönetimi ve iletişim</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-checkbox-circle-fill text-secondary mt-1 flex-shrink-0"></i>
                    <span>Yasal yükümlülüklerin yerine getirilmesi</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-checkbox-circle-fill text-secondary mt-1 flex-shrink-0"></i>
                    <span>Hizmet kalitesinin artırılması ve müşteri memnuniyetinin sağlanması</span>
                  </li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading font-bold text-2xl text-darkBlue mb-4 flex items-center">
                  <span className="w-2 h-8 bg-secondary rounded-full mr-3"></span>
                  3. İşlenen Kişisel Veriler
                </h2>
                <p className="font-body text-gray-700 leading-relaxed mb-4">
                  Vize danışmanlık hizmetlerimiz kapsamında aşağıdaki kişisel verileriniz işlenmektedir:
                </p>
                <ul className="space-y-2 font-body text-gray-700">
                  <li className="flex items-start space-x-2">
                    <i className="ri-arrow-right-s-fill text-secondary mt-1 flex-shrink-0"></i>
                    <span><strong>Kimlik Bilgileri:</strong> Ad, soyad, T.C. kimlik numarası, pasaport numarası, doğum tarihi, doğum yeri</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-arrow-right-s-fill text-secondary mt-1 flex-shrink-0"></i>
                    <span><strong>İletişim Bilgileri:</strong> Telefon numarası, e-posta adresi, adres bilgileri</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-arrow-right-s-fill text-secondary mt-1 flex-shrink-0"></i>
                    <span><strong>Finansal Bilgiler:</strong> Banka hesap bilgileri, gelir durumu</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-arrow-right-s-fill text-secondary mt-1 flex-shrink-0"></i>
                    <span><strong>Mesleki Bilgiler:</strong> Meslek, işyeri bilgileri, çalışma durumu</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-arrow-right-s-fill text-secondary mt-1 flex-shrink-0"></i>
                    <span><strong>Seyahat Bilgileri:</strong> Seyahat planı, konaklama bilgileri, daha önceki seyahatler</span>
                  </li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading font-bold text-2xl text-darkBlue mb-4 flex items-center">
                  <span className="w-2 h-8 bg-secondary rounded-full mr-3"></span>
                  4. Kişisel Verilerin Aktarılması
                </h2>
                <p className="font-body text-gray-700 leading-relaxed">
                  Kişisel verileriniz, vize başvuru süreçlerinin yürütülmesi amacıyla ilgili konsolosluklar, vize başvuru merkezleri ve yasal olarak yetkili kılınan kamu kurum ve kuruluşları ile paylaşılabilmektedir.
                </p>
              </div>

              <div>
                <h2 className="font-heading font-bold text-2xl text-darkBlue mb-4 flex items-center">
                  <span className="w-2 h-8 bg-secondary rounded-full mr-3"></span>
                  5. Kişisel Verilerin Toplanma Yöntemi
                </h2>
                <p className="font-body text-gray-700 leading-relaxed">
                  Kişisel verileriniz, vize danışmanlık hizmeti almak için ofisimize başvurduğunuzda, web sitemiz üzerinden iletişim formunu doldurduğunuzda, telefon veya e-posta yoluyla bizimle iletişime geçtiğinizde toplanmaktadır.
                </p>
              </div>

              <div>
                <h2 className="font-heading font-bold text-2xl text-darkBlue mb-4 flex items-center">
                  <span className="w-2 h-8 bg-secondary rounded-full mr-3"></span>
                  6. Kişisel Verilerin Saklanma Süresi
                </h2>
                <p className="font-body text-gray-700 leading-relaxed">
                  Kişisel verileriniz, vize başvuru sürecinin tamamlanmasından sonra yasal saklama yükümlülüklerimiz ve hizmet kalitesinin sağlanması amacıyla 10 yıl süreyle saklanmaktadır. Bu sürenin sonunda kişisel verileriniz silinir, yok edilir veya anonim hale getirilir.
                </p>
              </div>

              <div>
                <h2 className="font-heading font-bold text-2xl text-darkBlue mb-4 flex items-center">
                  <span className="w-2 h-8 bg-secondary rounded-full mr-3"></span>
                  7. Kişisel Veri Sahibinin Hakları
                </h2>
                <p className="font-body text-gray-700 leading-relaxed mb-4">
                  KVKK'nın 11. maddesi uyarınca, kişisel veri sahipleri olarak aşağıdaki haklara sahipsiniz:
                </p>
                <ul className="space-y-2 font-body text-gray-700">
                  <li className="flex items-start space-x-2">
                    <i className="ri-checkbox-circle-fill text-secondary mt-1 flex-shrink-0"></i>
                    <span>Kişisel verilerinizin işlenip işlenmediğini öğrenme</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-checkbox-circle-fill text-secondary mt-1 flex-shrink-0"></i>
                    <span>Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-checkbox-circle-fill text-secondary mt-1 flex-shrink-0"></i>
                    <span>Kişisel verilerin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-checkbox-circle-fill text-secondary mt-1 flex-shrink-0"></i>
                    <span>Kişisel verilerin yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-checkbox-circle-fill text-secondary mt-1 flex-shrink-0"></i>
                    <span>Kişisel verilerin eksik veya yanlış işlenmiş olması halinde bunların düzeltilmesini isteme</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-checkbox-circle-fill text-secondary mt-1 flex-shrink-0"></i>
                    <span>KVKK'nın 7. maddesinde öngörülen şartlar çerçevesinde kişisel verilerin silinmesini veya yok edilmesini isteme</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-checkbox-circle-fill text-secondary mt-1 flex-shrink-0"></i>
                    <span>Kişisel verilerin analizi yoluyla aleyhinize bir sonucun ortaya çıkmasına itiraz etme</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-checkbox-circle-fill text-secondary mt-1 flex-shrink-0"></i>
                    <span>Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız halinde zararın giderilmesini talep etme</span>
                  </li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading font-bold text-2xl text-darkBlue mb-4 flex items-center">
                  <span className="w-2 h-8 bg-secondary rounded-full mr-3"></span>
                  8. Başvuru Yöntemi
                </h2>
                <p className="font-body text-gray-700 leading-relaxed mb-4">
                  Yukarıda belirtilen haklarınızı kullanmak için aşağıdaki yöntemlerle başvuruda bulunabilirsiniz:
                </p>
                <div className="bg-gray-50 rounded-lg p-6">
                  <ul className="space-y-3 font-body text-gray-700">
                    <li className="flex items-start space-x-2">
                      <i className="ri-mail-line text-secondary mt-1 flex-shrink-0"></i>
                      <span><strong>E-posta:</strong> info@izmirvizedanismanlik.net</span>
                    </li>
                    <li className="flex items-start space-x-2">
                      <i className="ri-map-pin-line text-secondary mt-1 flex-shrink-0"></i>
                      <span><strong>Posta:</strong> Fevzi Paşa Mah. 847/1 Sk. No:8 Kat:4 Daire:4/405 Sağlık İş Hanı, Konak/İzmir</span>
                    </li>
                  </ul>
                </div>
                <p className="font-body text-gray-700 leading-relaxed mt-4">
                  Başvurularınız, talebin niteliğine göre en geç 30 gün içinde ücretsiz olarak sonuçlandırılacaktır. Ancak, işlemin ayrıca bir maliyeti gerektirmesi halinde, Kişisel Verileri Koruma Kurulu tarafından belirlenen tarifedeki ücret alınabilir.
                </p>
              </div>

              <div>
                <h2 className="font-heading font-bold text-2xl text-darkBlue mb-4 flex items-center">
                  <span className="w-2 h-8 bg-secondary rounded-full mr-3"></span>
                  9. Açık Rıza Beyanı
                </h2>
                <div className="bg-secondary/5 border-2 border-secondary rounded-xl p-6">
                  <p className="font-body text-gray-700 leading-relaxed">
                    İzmir Vize Danışmanlık'a vize başvurusu yapmak üzere başvurduğumda/iletişime geçtiğimde, yukarıda belirtilen amaçlar doğrultusunda kişisel verilerimin işlenmesine ve aktarılmasına <strong className="text-secondary">açık rıza</strong> verdiğimi beyan ederim.
                  </p>
                </div>
              </div>

              <div className="bg-lightBlue/30 rounded-xl p-8 mt-8">
                <p className="font-body text-gray-700 leading-relaxed">
                  <strong className="text-darkBlue">Son Güncelleme:</strong> 1 Ocak 2026
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}
